export interface AffiliateCodeBasicModel {
  id: number;
  name: string;
  code: string;
  createdTime: Date;
  lastModifiedTime: Date;
}
